import type { ReactNode } from 'react';

type Props = {
  label: string;
  /** The amount — usually a `PromoPrice` or a `StrikePrice`. */
  children: ReactNode;
};

/** One label / amount line of the payment summary. */
export function PaymentRow({ label, children }: Props) {
  return (
    <div className="flex items-center justify-between text-[12px] leading-[16px] text-[var(--co-ShipCard-mutedText,#6D707C)]">
      <span>{label}</span>
      <span className="tabular-nums text-[var(--co-ShipCard-titleColor,#FFFFFF)]">{children}</span>
    </div>
  );
}
